import { HTMLProps } from 'react'
import styled from 'styled-components'

export type IconProps = {
    fill?: string
    size?: number
    title?: string
    id?: string
} & HTMLProps<HTMLSpanElement>

export const SIconSpan = styled.span<IconProps>`
    align-items: center;
    justify-content: center;
    display: inline-flex;
    width: ${(props) => props.size}px;
    min-width: ${(props) => props.size}px;
    height: ${(props) => props.size}px;
    min-height: ${(props) => props.size}px;
`
